import {mixin} from "@/helpers/helper";
export default {
    namespaced: true,
    state: {
        githubTag: '',
        bread_active: null,
        bread_list: null,
        walletOk: 0,
        price: 0,
    },
    getters: {},
    mutations: {
        SET_DATA: function (state, data) {
            eval(`state.${data.name} = data.data`);
        }
    },
    actions: {
        getPrice(state) {
            axios.get('/api/v2/trades/getPrice/')
                .then(response => {
                    state.commit('SET_DATA', {
                        name: 'price', data: response.data
                    });
                })
        },

    }
}
